import { updatesData } from '@/mocks/home';

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-3">
              <i className="ri-flashlight-line"></i>
              滚动快讯
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              实时快讯
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              24小时不间断更新，最新爆料时刻掌握
            </p>
          </div>

          <div className="relative pl-8 md:pl-10 border-l-2 border-background-300">
            {updatesData.map((item, idx) => (
              <div
                key={item.id}
                className={`relative pb-8 last:pb-0 ${
                  idx === 0 ? 'animate-[fadeIn_0.4s_ease]' : ''
                }`}
              >
                <div className={`absolute -left-[25px] md:-left-[29px] w-4 h-4 rounded-full border-2 border-background-50 ${
                  idx === 0 ? 'bg-primary-500 border-primary-500' :
                  idx <= 2 ? 'bg-accent-500 border-accent-500' :
                  'bg-background-300 border-background-300'
                }`}></div>

                <div className="p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer">
                  <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                    <span className="text-[10px] md:text-xs text-foreground-400 flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-time-line"></i>
                      {item.time}
                    </span>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold whitespace-nowrap ${
                      item.tag === '突发' ? 'bg-primary-500 text-background-50' :
                      item.tag === '独家' ? 'bg-accent-500 text-background-50' :
                      item.tag === '今日爆' ? 'bg-primary-200 text-primary-800' :
                      item.tag === '实锤' ? 'bg-accent-200 text-accent-800' :
                      'bg-secondary-200 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-900">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}